import { Caption1, makeStyles, tokens } from "@fluentui/react-components";
import type { DocumentLink } from "@/engine/types";
import { DocLinkChip } from "./DocLinkChip";
import { groupDocumentLinks, presentLink, type DocumentChip, type LinkCatalog } from "./doc-links";

const useStyles = makeStyles({
  groups: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS,
  },
  group: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  label: {
    color: tokens.colorNeutralForeground3,
  },
});

/** 작업 · 일정 · 이슈로 묶은 연결. 빈 종류는 두지 않는다. */
export function DocumentLinkList({
  links,
  catalog,
  onOpen,
  onUnlink,
}: {
  links: readonly DocumentLink[];
  catalog: LinkCatalog;
  onOpen: (chip: DocumentChip) => void;
  onUnlink?: (linkId: string) => void;
}) {
  const styles = useStyles();
  const groups = groupDocumentLinks(links);
  if (!groups.length) return null;
  return (
    <div className={styles.groups} aria-label="연결된 항목">
      {groups.map((group) => (
        <section key={group.kind} className={styles.group} aria-label={group.label}>
          <Caption1 className={styles.label}>{group.label}</Caption1>
          <div>
            {group.links.map((link) => {
              const chip = presentLink(link, catalog);
              return (
                <DocLinkChip
                  key={link.id}
                  chip={chip}
                  onOpen={chip.missing ? undefined : () => onOpen(chip)}
                  onUnlink={onUnlink ? () => onUnlink(link.id) : undefined}
                />
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
